module.exports = {
    name: 'Appspace',
    aan: '123456789',
    address:
        'Level 14, Menara Darussalam, No 12 Jalan Pinang 50450 Kuala Lumpur, Malaysia',
    phone: '+603 2773 0949',
    email: 'christian.liam@appspace.com'
};



// WEBPACK FOOTER //
// ./modules/license/services/licenseOverviewService.billingContactInformation.mock.js